// src/components/strumenti/MarcaBollo.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };
const SOGLIA = 77.47;
const VALORE_BOLLO = 2.00;

export default function MarcaBollo() {
  const [importo, setImporto] = useState("");
  const [esenteIva, setEsenteIva] = useState(true);

  const v = leggiNumero(importo)||0;
  const richiestoBollo = esenteIva && v>SOGLIA;

  return (
    <div>
      <div style={{ marginBottom:12 }}>
        <label style={lbl}>Importo del documento (€)</label>
        <input value={importo} onChange={e=>setImporto(e.target.value)} style={inp} placeholder="Es. 150"/>
      </div>
      <label style={{ display:"flex", alignItems:"center", gap:8, marginBottom:16, cursor:"pointer" }}>
        <input type="checkbox" checked={esenteIva} onChange={e=>setEsenteIva(e.target.checked)} style={{ accentColor:"#059669" }}/>
        <span style={{ fontSize:12, color:"#374151" }}>Operazione esente/esclusa/non imponibile IVA</span>
      </label>

      {v>0 && (
        <div style={{ background: richiestoBollo ? "#fffbeb" : "#ecfdf5", border:`1px solid ${richiestoBollo?"#fde68a":"#a7f3d0"}`, borderRadius:10, padding:"14px 16px", textAlign:"center" }}>
          <div style={{ fontSize:16, fontWeight:800, color: richiestoBollo ? "#d97706" : "#059669" }}>
            {richiestoBollo ? `Marca da bollo dovuta (€ ${VALORE_BOLLO.toFixed(2)})` : "Marca da bollo non dovuta"}
          </div>
          {!esenteIva && (
            <div style={{ fontSize:11, color:"#6b7280", marginTop:6 }}>Operazione soggetta a IVA: la soglia si applica solo a documenti esenti/esclusi/non imponibili</div>
          )}
          {esenteIva && (
            <div style={{ fontSize:11, color:"#6b7280", marginTop:6 }}>Soglia di riferimento: € {SOGLIA.toFixed(2)}</div>
          )}
        </div>
      )}
      <div style={{ fontSize:10, color:"#9ca3af", marginTop:8, textAlign:"center" }}>
        Verifica indicativa sulla soglia generale (art. 6 Tariffa, DPR 642/1972) — casi particolari possono avere regole diverse.
      </div>

      <button onClick={()=>{setImporto("");setEsenteIva(true);}}
        style={{ marginTop:12, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
